/**
 * EventLayout
 * This is the main layout of the app
 */

import React, { Component } from "react"
import {
  Header,
  Body,
  LogoContainerMobile,
  SideContainer,
  SideContainerGlobal,
  SideContainerCountrySelectField,
  LogoContainerDesktop,
  ILogo,
} from "./styles"
import Logo from "components/Logo"
import theme from "styles/theme-main"
import { ThemeProvider } from "styled-components"
import CountrySelectField from "components/CountrySelectField"
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles"
import { convertMUI } from "utils/utils"
import {
  getSubdomainFromUrl,
  isCandidXMode,
  isProfileMode,
} from "utils/productUtils"
import { Helmet } from "react-helmet-async"
import Footer from "components/Footer"
import Maintenance from "components/Maintenance"
import { getClientLayoutConfiguration } from "utils/clientUtils"

export const LAYOUT_NAME = "RolesLayout"

class RolesLayout extends Component {
  componentDidMount() {
    const subdomain = getSubdomainFromUrl()
    if (subdomain && !this.props.organization) {
      this.props.getOrganization(subdomain)
    }
  }

  render() {
    const props = this.props

    const { process } = props

    if (props.organization) {
      const orgtheme = JSON.parse(props.organization.themeConfiguration || "{}")
      theme.logoWidth = orgtheme.logoWidth
      theme.logoMargin = orgtheme.logoMargin
      if (orgtheme.headerBGcolour) {
        theme.colors.headerBGcolour = orgtheme.headerBGcolour
      } else {
        theme.colors.headerBGcolour = "#ffffff"
      }
      theme.typography.fonts.regular = "Europa"
      theme.colors.primary = orgtheme.secondary || theme.colors.secondary
      theme.colors.secondary = orgtheme.secondary || theme.colors.secondary
      theme.menuItems.active = theme.colors.secondary
      theme.menuItems.selected = theme.colors.secondary
      theme.buttons.primary.background = theme.colors.secondary
      if (isProfileMode()) {
        theme.buttons.secondary.background = theme.colors.secondary
      }
    }

    theme.colors.headerBGcolour = isProfileMode()
      ? theme.colors.profileHeader
      : theme.colors.headerBGcolour

    const muitheme = createMuiTheme(convertMUI(theme))
    const logoURL = props.organization && props.organization.logoURL
    const mainStyle = {}

    const doublePixels = width => {
      let pixels = width && width.replace("px", "")
      return `${pixels * 2}px`
    }

    const clientName = props.organization && props.organization.name
    const bannerImage = props.organization && props.organization.bannerURL

    let title = `${clientName} | Careers at ${clientName}`
    let description = "View all our vacancies"
    const time = new Date().getTime()

    const { showLocationFilter } = getClientLayoutConfiguration(
      props.organization
    )

    return (
      <ThemeProvider theme={theme}>
        <MuiThemeProvider theme={muitheme}>
          <div style={mainStyle}>
            <Helmet>
              <title>{title}</title>
              <meta name="title" content={title} />
              <meta name="description" content={description} />
              <meta property="og:image" content={bannerImage} />
            </Helmet>
            <Maintenance />
            <Header {...props} showLocationFilter={showLocationFilter}>
              {!showLocationFilter ? (
                <SideContainer>&nbsp;</SideContainer>
              ) : (
                <SideContainerGlobal>&nbsp;</SideContainerGlobal>
              )}
              <LogoContainerMobile showLocationFilter={showLocationFilter}>
                <Logo
                  logoURL={`${logoURL}?id=${time}}`}
                  logoWidth={theme.logoWidth}
                  logoMargin={theme.logoMargin}
                  large
                  variant={isCandidXMode && "rareHeader"}
                  leftForMobile={showLocationFilter}
                />
              </LogoContainerMobile>
              <LogoContainerDesktop>
                {logoURL && (
                  <ILogo
                    src={logoURL}
                    logoWidth={doublePixels(theme.logoWidth)}
                    alt={"Company logo"}
                  />
                )}
              </LogoContainerDesktop>
              {showLocationFilter ? (
                <SideContainerCountrySelectField>
                  <CountrySelectField
                    label={"Switch country"}
                    organization={this.props.organization}
                  />
                </SideContainerCountrySelectField>
              ) : (
                <SideContainer>&nbsp;</SideContainer>
              )}
            </Header>

            <Body hasMessage={process && process.showOn === LAYOUT_NAME}>
              {props.children}
            </Body>
            <Footer />
          </div>
        </MuiThemeProvider>
      </ThemeProvider>
    )
  }
}

export default RolesLayout
